import api, { setHeaderToken, removeHeaderToken } from "../../../apis/Api";

import router from "@/router";
import { allMixin } from "@/mixins/allMixin.js";

export default {
  namespaced: true,
  state: {
    userList: {},
    roleList: {},
    countryList: {},
    departmentList: {}
  },
  getters: {
    getUserList(state) {
      return state.userList;
    },
    getRoleList(state) {
      return state.roleList;
    },
    getCountryList(state) {
      return state.countryList;
    },
    getDepartmentList(state) {
      return state.departmentList;
    }
  },
  mutations: {
    setUserList(state, payload) {
      state.userList = payload;
    },
    setRoleList(state, payload) {
      state.roleList = payload;
    },
    setCountryList(state, payload) {
      state.countryList = payload;
    },
    setDepartmentList(state, payload) {
      state.departmentList = payload;
    }
  },
  actions: {
    user({ state, commit, dispatch, rootGetters }, payload) {
      dispatch("setLoading", true);
      let token = localStorage.getItem("token");
      return new Promise((resolve, reject) => {
        api({
          method: payload.method,
          url: payload.url,
          data: payload.data,
          params: payload.params,
          withCredentials: true,
          headers: {
            Authorization: "Bearer " + token
          }
        })
          .then(res => {
            resolve(res);
            dispatch("setLoading", false);
          })
          .catch(err => {
            console.log("authjs=err" + err);
            reject(err);
            dispatch("setLoading", false);
            return false;
          });
      });
    },
    getUserList({ state, commit, dispatch, rootGetters }, payload) {
      dispatch("setLoading", true);
      let token = localStorage.getItem("token");
      api({
        method: "get",
        url: payload.url,
        params: payload.params,
        headers: {
          Authorization: "Bearer " + token
        }
      })
        .then(res => {
          if (res.respond.status == "success") {
            commit("setUserList", res.respond.data);
          } else if (res.respond.status == "forbidden") {
            allMixin.methods.removeSession()
            router.push(`/login`).catch(() => {});
          }
          dispatch("setLoading", false);
        })
        .catch(err => {
          console.log("authjs=err" + err);
          dispatch("setLoading", false);
          return false;
        });
    },
    getRoleList({ state, commit, dispatch, rootGetters }, payload) {
      dispatch("setLoading", true);
      let token = localStorage.getItem("token");
      api({
        method: "get",
        url: "role/list",
        params: { RoleType: "ADMIN" },
        headers: {
          Authorization: "Bearer " + token
        }
      })
        .then(res => {
          commit("setRoleList", res);
          // if (res.respond.status == "forbidden") {
          //   localStorage.removeItem("token")
          //   localStorage.removeItem("refreshToken")
          //   router.push(`/login`).catch(() => { });
          // }
          dispatch("setLoading", false);
        })
        .catch(err => {
          console.log("authjs=err" + err);
          dispatch("setLoading", false);
          return false;
        });
    },
    getCountryList({ state, commit, dispatch, rootGetters }, payload) {
      dispatch("setLoading", true);
      let token = localStorage.getItem("token");
      api({
        method: "get",
        url: "get/countrycode",
        headers: {
          Authorization: "Bearer " + token
        }
      })
        .then(res => {
          if (res.respond.status == "success") {
            commit("setCountryList", res.respond.data);
          } else if (res.respond.status == "forbidden") {
            allMixin.methods.removeSession()
            router.push(`/login`).catch(() => {});
          }
          dispatch("setLoading", false);
        })
        .catch(err => {
          console.log("authjs=err" + err);
          dispatch("setLoading", false);
          return false;
        });
    },
    getDepartmentList({ state, commit, dispatch, rootGetters }, payload) {
      dispatch("setLoading", true);
      let token = localStorage.getItem("token");
      api({
        method: "get",
        url: "get/department",
        headers: {
          Authorization: "Bearer " + token
        }
      })
        .then(res => {
          if (res.respond.status == "success") {
            commit("setDepartmentList", res.respond.data);
          } else if (res.respond.status == "forbidden") {
            allMixin.methods.removeSession()
            router.push(`/login`).catch(() => {});
          }
          dispatch("setLoading", false);
        })
        .catch(err => {
          console.log("authjs=err" + err);
          dispatch("setLoading", false);
          return false;
        });
    },

    setLoading({ commit }, payload) {
      commit("loader/setLoading", payload, {
        root: true
      });
    }
  }
};
